import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/images/pointmaps.png'


const _hoisted_1 = { class: "flex h-screen overflow-hidden" }
const _hoisted_2 = { class: "relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden" }
const _hoisted_3 = { class: "w-11/12 mx-auto sm:px-8" }
const _hoisted_4 = { class: "bg-[#D9D9D9] p-3 rounded-md mb-5" }
const _hoisted_5 = { class: "flex flex-row justify-start my-8" }
const _hoisted_6 = { class: "font-bold text-[23px] ml-2 md:ml-10" }
const _hoisted_7 = { class: "flex flex-row justify-center gap-5 my-8" }
const _hoisted_8 = { class: "flex flex-col justify-between items-center m-0 p-0 text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "font-extrabold" }, "Casablanca", -1)
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "12/10/2023", -1)
const _hoisted_13 = { class: "flex flex-row justify-center items-center m-0 p-0" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex flex-col justify-between items-center m-0 p-0 text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "52",
      height: "52",
      fill: "url(#pattern0)"
    }),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("pattern", {
        id: "pattern0",
        patternContentUnits: "objectBoundingBox",
        width: "1",
        height: "1"
      }, [
        /*#__PURE__*/_createElementVNode("use", {
          "xlink:href": "#image0_17_57",
          transform: "scale(0.00195312)"
        })
      ]),
      /*#__PURE__*/_createElementVNode("image", {
        id: "image0_17_57",
        width: "512",
        height: "512",
        "xlink:href": "data:image/png;base64,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"
      })
    ])
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-extrabold mt-3" }, "Agadir", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "12/10/2023", -1)
const _hoisted_19 = { class: "flex justify-between py-8" }
const _hoisted_20 = { class: "font-bold text-[23px]" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.10938 18.1631L15.2191 12.2749L9.33089 6.16513",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.11523 9.0459L12.0689 15.0919L18.1149 9.13816",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "min-w-full leading-normal"
}
const _hoisted_26 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_27 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_28 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 md:w-4 h-4",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("td", { class: "w-4 md:w-8 h-8 p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#1CA521"
    })
  ])
], -1)
const _hoisted_34 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_35 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_36 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_37 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_38 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 md:w-4 h-4",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("td", { class: "w-4 md:w-8 h-8 p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#1CA521"
    })
  ])
], -1)
const _hoisted_44 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_45 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_46 = { class: "flex justify-between py-8" }
const _hoisted_47 = { class: "font-bold text-[23px]" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.10938 18.1631L15.2191 12.2749L9.33089 6.16513",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.11523 9.0459L12.0689 15.0919L18.1149 9.13816",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "min-w-full leading-normal"
}
const _hoisted_53 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_54 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_55 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 md:w-4 h-4",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "w-4 md:w-8 h-8 p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#1CA521"
    })
  ])
], -1)
const _hoisted_61 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_62 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }, " Document 2 ")
], -1)
const _hoisted_64 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", { class: "w-8 h-8 px-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#F41E1E"
    })
  ])
], -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Alert")
  ])
], -1)
const _hoisted_71 = { class: "flex justify-between py-8" }
const _hoisted_72 = { class: "font-bold text-[23px]" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.10938 18.1631L15.2191 12.2749L9.33089 6.16513",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.11523 9.0459L12.0689 15.0919L18.1149 9.13816",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = {
  key: 2,
  class: "min-w-full leading-normal"
}
const _hoisted_78 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_79 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_80 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_83 = [
  _hoisted_81,
  _hoisted_82
]
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", { class: "w-8 h-8 px-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#1CA521"
    })
  ])
], -1)
const _hoisted_86 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_87 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }, " Document 2 ")
], -1)
const _hoisted_89 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_92 = [
  _hoisted_90,
  _hoisted_91
]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", { class: "w-8 h-8 px-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#F41E1E"
    })
  ])
], -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Alert")
  ])
], -1)
const _hoisted_96 = { class: "flex justify-between py-8" }
const _hoisted_97 = { class: "font-bold text-[23px]" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.10938 18.1631L15.2191 12.2749L9.33089 6.16513",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.11523 9.0459L12.0689 15.0919L18.1149 9.13816",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = {
  key: 3,
  class: "min-w-full leading-normal mb-10"
}
const _hoisted_103 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_104 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_105 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_108 = [
  _hoisted_106,
  _hoisted_107
]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("td", { class: "w-8 h-8 px-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#1CA521"
    })
  ])
], -1)
const _hoisted_111 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_112 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }, " Document 2 ")
], -1)
const _hoisted_114 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_117 = [
  _hoisted_115,
  _hoisted_116
]
const _hoisted_118 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("td", { class: "w-8 h-8 px-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "34",
    height: "34",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      cx: "17",
      cy: "17",
      r: "17",
      fill: "#F41E1E"
    })
  ])
], -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Alert")
  ])
], -1)
const _hoisted_121 = {
  key: 4,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "modal-overlay absolute w-full h-full bg-gray-900 opacity-50" }, null, -1)
const _hoisted_123 = { class: "relative w-[97%] md:w-2/3 p-1 md:p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_125 = { class: "sr-only" }
const _hoisted_126 = { class: "w-full" }
const _hoisted_127 = { class: "min-w-full leading-normal" }
const _hoisted_128 = { class: "px-5 py-5 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" }
const _hoisted_129 = { class: "px-5 py-5 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" }
const _hoisted_130 = { class: "px-5 py-5 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" }
const _hoisted_131 = { class: "px-5 py-5 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider" }
const _hoisted_132 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_133 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_134 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_137 = [
  _hoisted_135,
  _hoisted_136
]
const _hoisted_138 = /*#__PURE__*/_createElementVNode("td", { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_139 = { class: "p-1 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_140 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_141 = { class: "text-xs md:text-base" }
const _hoisted_142 = { class: "p-0 md:p-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_143 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_144 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_147 = [
  _hoisted_145,
  _hoisted_146
]
const _hoisted_148 = /*#__PURE__*/_createElementVNode("td", { class: "p-0 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_149 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_150 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_151 = { class: "text-xs md:text-base" }
const _hoisted_152 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_153 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_154 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_157 = [
  _hoisted_155,
  _hoisted_156
]
const _hoisted_158 = /*#__PURE__*/_createElementVNode("td", { class: "p-0 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_159 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_160 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_161 = { class: "text-xs md:text-base" }
const _hoisted_162 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_163 = { class: "text-gray-600 whitespace-no-wrap text-base font-bold" }
const _hoisted_164 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25ZM9.75 12C9.75 10.7574 10.7574 9.75 12 9.75C13.2426 9.75 14.25 10.7574 14.25 12C14.25 13.2426 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2426 9.75 12Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12 3.25C7.48587 3.25 4.44529 5.9542 2.68057 8.24686L2.64874 8.2882C2.24964 8.80653 1.88206 9.28392 1.63269 9.8484C1.36564 10.4529 1.25 11.1117 1.25 12C1.25 12.8883 1.36564 13.5471 1.63269 14.1516C1.88206 14.7161 2.24964 15.1935 2.64875 15.7118L2.68057 15.7531C4.44529 18.0458 7.48587 20.75 12 20.75C16.5141 20.75 19.5547 18.0458 21.3194 15.7531L21.3512 15.7118C21.7504 15.1935 22.1179 14.7161 22.3673 14.1516C22.6344 13.5471 22.75 12.8883 22.75 12C22.75 11.1117 22.6344 10.4529 22.3673 9.8484C22.1179 9.28391 21.7504 8.80652 21.3512 8.28818L21.3194 8.24686C19.5547 5.9542 16.5141 3.25 12 3.25ZM3.86922 9.1618C5.49864 7.04492 8.15036 4.75 12 4.75C15.8496 4.75 18.5014 7.04492 20.1308 9.1618C20.5694 9.73159 20.8263 10.0721 20.9952 10.4545C21.1532 10.812 21.25 11.2489 21.25 12C21.25 12.7511 21.1532 13.188 20.9952 13.5455C20.8263 13.9279 20.5694 14.2684 20.1308 14.8382C18.5014 16.9551 15.8496 19.25 12 19.25C8.15036 19.25 5.49864 16.9551 3.86922 14.8382C3.43064 14.2684 3.17374 13.9279 3.00476 13.5455C2.84684 13.188 2.75 12.7511 2.75 12C2.75 11.2489 2.84684 10.812 3.00476 10.4545C3.17374 10.0721 3.43063 9.73159 3.86922 9.1618Z",
  fill: "#1C274C"
}, null, -1)
const _hoisted_167 = [
  _hoisted_165,
  _hoisted_166
]
const _hoisted_168 = /*#__PURE__*/_createElementVNode("td", { class: "p-0 md:p-5 border-b border-gray-200 bg-white text-sm" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "fill-current w-4 h-4 mr-2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z" })
    ])
  ])
], -1)
const _hoisted_169 = { class: "px-5 py-5 border-b border-gray-200 bg-white text-sm" }
const _hoisted_170 = { class: "bg-red-600 hover:bg-red-400 text-white font-bold py-2 px-4 rounded inline-flex items-center" }
const _hoisted_171 = { class: "text-xs md:text-base" }

import { ref } from 'vue'
import SidebarView from './partials/SidebarView.vue'
import HeaderView from './partials/HeaderView.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DriverView',
  setup(__props) {

const isDropdownOpen = ref(false)
const isDropdowndoc = ref(false)
const isDropdowndocDrivers = ref(false)
const isDropdowndocTruck = ref(false)
const isDropdowndocTrailer = ref(false)
const selectedLanguage = ref('English') 
const isShowView = ref(false) 

const toggleDropdown = () => {

    isDropdownOpen.value = !isDropdownOpen.value;
}
const changeLanguage = (language:string) => {
      selectedLanguage.value = language;
      isDropdownOpen.value = false;
}
const showView = () => {
  isShowView.value = true
}
const cancelShowView = () => {
  isShowView.value = false
}

const documentDropdown = () => {
  isDropdowndoc.value = !isDropdowndoc.value;
}
const documentDropdownDrivers = () => {
  isDropdowndocDrivers.value = !isDropdowndocDrivers.value;
}
const documentDropdownTruck = () => {
  isDropdowndocTruck.value = !isDropdowndocTruck.value;
}
const documentDropdownTrailer = () => {
  isDropdowndocTrailer.value = !isDropdowndocTrailer.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarView),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(HeaderView),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.$t('Shipmentinformation')) + " n° 177854", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('Homebusiness')), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Startat')) + " 11 am ", 1),
                _hoisted_12
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: require('@/assets/images/shipment.png'),
                  alt: "My Image"
                }, null, 8, _hoisted_14)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _hoisted_17,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Homebusiness')), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Startat')) + " 11 am", 1),
                _hoisted_18
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("h1", _hoisted_20, _toDisplayString(_ctx.$t('Companies')), 1),
            (!isDropdowndoc.value)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  onClick: documentDropdown,
                  class: "cursor-pointer",
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_22))
              : (_openBlock(), _createElementBlock("svg", {
                  key: 1,
                  class: "cursor-pointer",
                  onClick: documentDropdown,
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_24))
          ]),
          (isDropdowndoc.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_25, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('Document')) + " 1", 1)
                    ]),
                    _createElementVNode("td", _hoisted_28, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_31))
                    ]),
                    _hoisted_32,
                    _hoisted_33,
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("button", _hoisted_35, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Alert')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_36, [
                      _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.$t('Document')) + " 1", 1)
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_41))
                    ]),
                    _hoisted_42,
                    _hoisted_43,
                    _createElementVNode("td", _hoisted_44, [
                      _createElementVNode("button", _hoisted_45, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Alert')), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h1", _hoisted_47, _toDisplayString(_ctx.$t('Driver')), 1),
            (!isDropdowndocDrivers.value)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  onClick: documentDropdownDrivers,
                  class: "cursor-pointer",
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_49))
              : (_openBlock(), _createElementBlock("svg", {
                  key: 1,
                  class: "cursor-pointer",
                  onClick: documentDropdownDrivers,
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_51))
          ]),
          (isDropdowndocDrivers.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_52, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_53, [
                      _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.$t('Document')) + " 1", 1)
                    ]),
                    _createElementVNode("td", _hoisted_55, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_58))
                    ]),
                    _hoisted_59,
                    _hoisted_60,
                    _createElementVNode("td", _hoisted_61, [
                      _createElementVNode("button", _hoisted_62, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Alert')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_63,
                    _createElementVNode("td", _hoisted_64, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_67))
                    ]),
                    _hoisted_68,
                    _hoisted_69,
                    _hoisted_70
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("h1", _hoisted_72, _toDisplayString(_ctx.$t('Track')), 1),
            (!isDropdowndocTruck.value)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  onClick: documentDropdownTruck,
                  class: "cursor-pointer",
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_74))
              : (_openBlock(), _createElementBlock("svg", {
                  key: 1,
                  class: "cursor-pointer",
                  onClick: documentDropdownTruck,
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_76))
          ]),
          (isDropdowndocTruck.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_77, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_78, [
                      _createElementVNode("p", _hoisted_79, _toDisplayString(_ctx.$t('Document')) + " 1 ", 1)
                    ]),
                    _createElementVNode("td", _hoisted_80, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_83))
                    ]),
                    _hoisted_84,
                    _hoisted_85,
                    _createElementVNode("td", _hoisted_86, [
                      _createElementVNode("button", _hoisted_87, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Alert')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_88,
                    _createElementVNode("td", _hoisted_89, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_92))
                    ]),
                    _hoisted_93,
                    _hoisted_94,
                    _hoisted_95
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("h1", _hoisted_97, _toDisplayString(_ctx.$t('Trailer')), 1),
            (!isDropdowndocTrailer.value)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  onClick: documentDropdownTrailer,
                  class: "cursor-pointer",
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_99))
              : (_openBlock(), _createElementBlock("svg", {
                  key: 1,
                  class: "cursor-pointer",
                  onClick: documentDropdownTrailer,
                  width: "25",
                  height: "25",
                  viewBox: "0 0 25 25",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, _hoisted_101))
          ]),
          (isDropdowndocTrailer.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_102, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_103, [
                      _createElementVNode("p", _hoisted_104, _toDisplayString(_ctx.$t('Document')) + " 1 ", 1)
                    ]),
                    _createElementVNode("td", _hoisted_105, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_108))
                    ]),
                    _hoisted_109,
                    _hoisted_110,
                    _createElementVNode("td", _hoisted_111, [
                      _createElementVNode("button", _hoisted_112, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('Alert')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_113,
                    _createElementVNode("td", _hoisted_114, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: showView,
                        class: "m-auto cursor-pointer",
                        width: "25px",
                        height: "25px",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, _hoisted_117))
                    ]),
                    _hoisted_118,
                    _hoisted_119,
                    _hoisted_120
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (isShowView.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                _hoisted_122,
                _createElementVNode("div", _hoisted_123, [
                  _createElementVNode("button", {
                    onClick: cancelShowView,
                    class: "bg-slate-100 mt-[-30px] text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white",
                    "data-modal-toggle": "deleteModal"
                  }, [
                    _hoisted_124,
                    _createElementVNode("span", _hoisted_125, _toDisplayString(_ctx.$t('Closemodal')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("table", _hoisted_127, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_128, _toDisplayString(_ctx.$t('Type')), 1),
                          _createElementVNode("th", _hoisted_129, _toDisplayString(_ctx.$t('View')), 1),
                          _createElementVNode("th", _hoisted_130, _toDisplayString(_ctx.$t('File')), 1),
                          _createElementVNode("th", _hoisted_131, _toDisplayString(_ctx.$t('ACTION')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_132, [
                            _createElementVNode("p", _hoisted_133, _toDisplayString(_ctx.$t('Companies')), 1)
                          ]),
                          _createElementVNode("td", _hoisted_134, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: showView,
                              class: "m-auto",
                              width: "25px",
                              height: "25px",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_137))
                          ]),
                          _hoisted_138,
                          _createElementVNode("td", _hoisted_139, [
                            _createElementVNode("button", _hoisted_140, [
                              _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.$t('SIGNALER')), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_142, [
                            _createElementVNode("p", _hoisted_143, _toDisplayString(_ctx.$t('Driver')), 1)
                          ]),
                          _createElementVNode("td", _hoisted_144, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: showView,
                              class: "m-auto",
                              width: "25px",
                              height: "25px",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_147))
                          ]),
                          _hoisted_148,
                          _createElementVNode("td", _hoisted_149, [
                            _createElementVNode("button", _hoisted_150, [
                              _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.$t('SIGNALER')), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_152, [
                            _createElementVNode("p", _hoisted_153, _toDisplayString(_ctx.$t('Track')), 1)
                          ]),
                          _createElementVNode("td", _hoisted_154, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: showView,
                              class: "m-auto",
                              width: "25px",
                              height: "25px",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_157))
                          ]),
                          _hoisted_158,
                          _createElementVNode("td", _hoisted_159, [
                            _createElementVNode("button", _hoisted_160, [
                              _createElementVNode("span", _hoisted_161, _toDisplayString(_ctx.$t('SIGNALER')), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_162, [
                            _createElementVNode("p", _hoisted_163, _toDisplayString(_ctx.$t('Trailer')), 1)
                          ]),
                          _createElementVNode("td", _hoisted_164, [
                            (_openBlock(), _createElementBlock("svg", {
                              onClick: showView,
                              class: "m-auto",
                              width: "25px",
                              height: "25px",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, _hoisted_167))
                          ]),
                          _hoisted_168,
                          _createElementVNode("td", _hoisted_169, [
                            _createElementVNode("button", _hoisted_170, [
                              _createElementVNode("span", _hoisted_171, _toDisplayString(_ctx.$t('SIGNALER')), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})